import React from 'react';

import { agentsBaseAdminRoute } from '@lumapps/agent-hub-agents/routes';
import { agentHubAudienceManagementAdminRoute } from '@lumapps/agent-hub-audience-management/routes';
import { agentHubBaseSourcesAdminRoute } from '@lumapps/agent-hub-sources/routes';
import { canAccessAgentHubAdminSelector } from '@lumapps/agent-hub/ducks/selectors';
import { AGENT_HUB } from '@lumapps/agent-hub/keys';
import {
    SideNavigationSection as Section,
    SideNavigationItem,
    type SideNavigationSectionProps,
} from '@lumapps/lumx-back-office/components/SideNavigation';
import { robotSparkle } from '@lumapps/lumx/custom-icons';
import { useSelector } from '@lumapps/redux/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

/**
 * Backoffice side navigation section for the Agent hub
 */
export const AgentHubSideNavigation: React.FC<Partial<SideNavigationSectionProps>> = (props) => {
    const { translateKey } = useTranslate();
    const canAccessAgentHubAdmin = useSelector(canAccessAgentHubAdminSelector);

    if (!canAccessAgentHubAdmin) {
        return null;
    }

    return (
        <Section {...props} header={translateKey(GLOBAL.AGENT_HUB)} id="agent-hub">
            <SideNavigationItem label={translateKey(AGENT_HUB.AGENT_STUDIO)} id="agent-studio" icon={robotSparkle}>
                <SideNavigationItem
                    label={translateKey(GLOBAL.AGENTS)}
                    id="agent-studio-agents"
                    route={agentsBaseAdminRoute}
                />
                <SideNavigationItem
                    label={translateKey(AGENT_HUB.KNOWLEDGE_SOURCES)}
                    id="agent-studio-sources"
                    route={agentHubBaseSourcesAdminRoute}
                />
                <SideNavigationItem
                    label={translateKey(AGENT_HUB.AUDIENCE_MANAGEMENT)}
                    id="agent-studio-audience-management"
                    route={agentHubAudienceManagementAdminRoute}
                />
            </SideNavigationItem>
        </Section>
    );
};

AgentHubSideNavigation.displayName = 'SideNavigationItem';
